export const SEAT_BUTTON_SHAPE_OPTIONS = [
  { value: "tent", label: "텐트" },
  { value: "table", label: "테이블" },
  { value: "picnic", label: "피크닉" },
  { value: "house", label: "하우스" },
] as const;

export type SeatButtonShape = (typeof SEAT_BUTTON_SHAPE_OPTIONS)[number]["value"];

type SeatShapeGeometry =
  | {
      kind: "rect";
    }
  | {
      kind: "polygon";
      points: number[];
    };

const SUPPORTED_SHAPES = new Set<SeatButtonShape>(SEAT_BUTTON_SHAPE_OPTIONS.map((option) => option.value));

const roundPoint = (value: number) => Math.round(value);

export const getSeatButtonShape = (meta: Record<string, unknown> | null | undefined): SeatButtonShape | null => {
  const value = meta?.button_shape;
  return typeof value === "string" && SUPPORTED_SHAPES.has(value as SeatButtonShape) ? (value as SeatButtonShape) : null;
};

export const withSeatButtonShapeMeta = (
  meta: Record<string, unknown> | null | undefined,
  shape: SeatButtonShape,
): Record<string, unknown> => ({
  ...(meta || {}),
  button_shape: shape,
});

export const getSeatShapeGeometry = (shape: SeatButtonShape, width: number, height: number): SeatShapeGeometry => {
  if (shape === "table") {
    return { kind: "rect" };
  }

  if (shape === "tent") {
    return {
      kind: "polygon",
      points: [
        roundPoint(width * 0.5),
        roundPoint(height * 0.02),
        roundPoint(width * 0.98),
        roundPoint(height * 0.96),
        roundPoint(width * 0.02),
        roundPoint(height * 0.96),
      ],
    };
  }

  if (shape === "picnic") {
    return {
      kind: "polygon",
      points: [
        roundPoint(width * 0.12),
        roundPoint(height * 0.02),
        roundPoint(width * 0.88),
        roundPoint(height * 0.02),
        roundPoint(width),
        roundPoint(height * 0.5),
        roundPoint(width * 0.88),
        roundPoint(height * 0.98),
        roundPoint(width * 0.12),
        roundPoint(height * 0.98),
        0,
        roundPoint(height * 0.5),
      ],
    };
  }

  return {
    kind: "polygon",
    points: [
      roundPoint(width * 0.5),
      roundPoint(height * 0.03),
      roundPoint(width * 0.96),
      roundPoint(height * 0.35),
      roundPoint(width * 0.96),
      roundPoint(height * 0.98),
      roundPoint(width * 0.04),
      roundPoint(height * 0.98),
      roundPoint(width * 0.04),
      roundPoint(height * 0.35),
    ],
  };
};

export const getSeatShapeTextOffset = (shape: SeatButtonShape | null, height: number) => {
  if (shape === "tent") {
    return Math.round(height * 0.06);
  }
  if (shape === "house") {
    return Math.round(height * 0.05);
  }
  return 0;
};
